<template>
  <div class="resource-index maxW">
    <CommonCate
      @changeCateOption="changeCateOption"
      @changeOrderType="changeOrderType"
    />
    <!-- <ItcCate
      v-if="isTencentCloud"
      @emitListData="getListData"
    /> -->
    <!-- <div
      class="resource-cate"
      v-else
    >
      <div class="cate-left">{{$t('homepage.resource_cate')}}：</div>
      <div class="cate-right">
        <ul>
          <li
            v-for="item in cateList"
            :key="item.id"
            @click="selectCate(item.id)"
          >
            <span :class="activeClass==item.id?'cate-active':''">{{item.name}}</span>
          </li>
        </ul>
      </div>
      <br style="clear:both;" />
    </div> -->
    <div class="resource-content">
      <!-- <div class="filter-nav">
        <template>
          <el-radio-group v-model="orderby">
            <el-radio
                label="create_time"
                @click="toggle_order('time')"
            >
              {{$t('homepage.time')}}<i class="el-icon-sort-down"></i>
            </el-radio>
            <el-radio
                label="downloads"
                @click="toggle_order('download')"
            >
              热度<i class="el-icon-sort-down"></i>
            </el-radio>
          </el-radio-group>
        </template>
      </div> -->
      <div class="resources-container clear">
        <div class="resource-card-box fl">
          <div class="cards-box">
            <ul class="cards-box-ul clear">
              <li
                class="cards-li fl"
                v-for="(item, index) in resourceListData"
                :key="index"
              >
                <div class="cards-li-title clear">
                  <a
                    class="res-title"
                    @click="toResourceDetails(item)"
                    href="javascript:;"
                    :title="item.name"
                    >{{ item.name }}.{{ item.postfix }}
                  </a>
                  <i class="resource_icon fr">
                    <img
                      :src="
                        hostURL +
                        '/static/index/images/format/resourceicon' +
                        item.file_type +
                        '.png'
                      "
                    />
                  </i>
                </div>
                <div class="rate-star clear">
                  <div class="rate-score fl clear">
                    <el-rate
                      :value="item.co_score / 2"
                      disabled
                      class="fl"
                    ></el-rate>
                    <strong>{{ formRate(item.co_score) }}</strong>
                  </div>
                </div>
                <div class="user-infos">
                  <!-- <router-link :to="{path: '/teach/space', query: {id: item.u_id}}"> -->
                  <a href="javascript:;"
                    ><img :src="item.u_avatar_path" />{{ item.u_name }}</a
                  >
                  <!-- <p
                      class="cate"
                      :title="item.cate_name?item.cate_name: $t('global.defaultSort')"
                  >{{item.cate_name?item.cate_name: $t('global.defaultSort')}}</p> -->

                  <span class="video_view"
                    >{{ item.clicks }}{{ $t("global.view") }}</span
                  >
                  <!-- </router-link> -->
                </div>
              </li>
              <div class="dependent" v-if="resourceListData.length == 0">
                <i class="ipng image_state01"></i>
                <p>- {{ $t("global.noData") }} -</p>
              </div>
            </ul>
            <div class="pageBox">
              <el-pagination
                v-if="total_number > page_size"
                @current-change="change_page"
                :page-size="page_size"
                :current-page="page_index"
                layout="total,prev, pager, next,jumper"
                :total="total_number"
              ></el-pagination>
            </div>
          </div>
        </div>
        <!-- <div class="resource-rank fr">
          <div
            class="upload-btn-div"
            @click="uploadResource"
            v-if="!isTencentCloud"
          >
            					<i class="ipng icon_up"></i>
            <img
              src="../../../assets/images/上传-2.png"
              alt=""
            >
            <i>{{$t('homepage.uploadResource')}}</i>
          </div>
          <div class="upload-rank">
            <el-card
              class="box-card"
              shadow="never"
            >
              <div
                slot="header"
                class="clearfix"
              >
                <span class="humantitle">{{$t('homepage.ranking')}}</span>
              </div>
              <div
                v-for="(item,index) in downloadData"
                :key="index"
                class="text item humanItem"
              >
                <i :class="[(index+1)<4?'humanNun yellowC':'humanNun']">{{index+1}}</i>
                <a
                  @click="toResourceDetails(item)"
                  href="javascript:;"
                  :title="item.name"
                >
                  <p>{{item.name}}</p>
                  <div><span>{{$t('global.downCount')}}：</span> <span>{{item.downloads}}</span></div>
                </a>
              </div>
              <div
                class="no-data"
                v-if="downloadData.length==0"
              >- {{$t('global.noData')}} -</div>
            </el-card>
          </div>
        </div> -->
      </div>
    </div>
    <el-dialog
      class="resourceDialog"
      :title="$t('homepage.uploadRes')"
      width="800px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="resourceForm"
        ref="resourceForm"
        :inline="true"
        label-width="150px"
        label-position="left"
        :close-on-click-modal="false"
      >
        <el-form-item
          :label="$t('homepage.uploadRes')"
          required
          class="long-item upload-btn-item"
        >
          <template>
            <uploader
              class="uploader-example"
              ref="uploader"
              :options="uploadOptions"
              :file-status-text="statusText"
              @file-added="fileAdded"
              @files-submitted="fileSubmit"
              @file-progress="fileProgress"
              @file-success="fileSuccess"
              @file-error="fileFail"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :single="true" :attrs="attrs">{{
                  $t("homepage.chooseRes")
                }}</uploader-btn>
                <el-tooltip :content="$t('homepage.resTypes')" placement="top">
                  <i class="el-icon-info tip-word"></i>
                </el-tooltip>
              </uploader-drop>
              <div class="progress-tips" v-if="fileAdd != null">
                <span class="file-name">{{ fileAdd.name }}</span>
                <span class="file-type">{{ fileAdd.fileType }}</span>
                <span class="progress-value" v-if="percentage < 100"
                  >{{ percentage }}%</span
                >
                <span class="progress-value" v-else>
                  <i class="el-icon-success"></i>
                </span>
              </div>
            </uploader>
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('homepage.resName')"
          required
          class="long-item resource-name-item"
        >
          <el-input
            v-model.trim="resourceForm.name"
            maxlength="20"
            :placeholder="$t('form.maxl20')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('global.resourceCate')"
          required
          class="long-item"
        >
          <el-select
            v-model="resourceForm.cate_id"
            :placeholder="$t('global.choose')"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('global.allowDown')"
          required
          class="long-item"
        >
          <el-radio-group v-model="resourceForm.is_download">
            <el-radio :label="1">{{ $t("global.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("global.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('global.allowShare')"
          required
          class="long-item"
        >
          <el-radio-group v-model="resourceForm.is_share">
            <el-radio :label="1">{{ $t("global.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("global.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="btns-item">
          <el-button @click="dialogVisible = false">{{
            $t("global.cancel")
          }}</el-button>
          <el-button
            type="primary"
            v-loading.fullscreen="submitLoading"
            :element-loading-text="$t('form.submiting')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            @click="submit"
            >{{ $t("global.save") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ItcCate from "../itcComponents/cateOptions.vue";
import CommonCate from "@/components/common-v2/category.vue";
export default {
  data() {
    return {
      itcVideoCate: [],
      itcVideoCate2: [],
      hostURL: "",
      userId: this.$g.user_id,
      // 分页：
      page_index: 1,
      page_size: 12,
      total_number: 0,
      keyword: this.$route.query.keyword, //首页搜索跳转到此页面时带的关键字
      create_id: 0,
      orgList: [],
      orgLevel3: [],
      subjectList: [],
      orgChecked:
        this.$route.params.sectionId == undefined
          ? 0
          : this.$route.params.sectionId,
      subjectChecked:
        this.$route.params.subjectId == undefined
          ? 0
          : this.$route.params.subjectId,
      //资料列表：
      orderby: "create_time",
      resourceListData: [],
      // 下载排行：
      downloadData: [],
      // 收藏排行：
      favsData: [],
      // 上传资料弹窗：
      dialogVisible: false,
      resourceForm: {
        resName: "",
        name: "",
        study_section_id: 2, //学段
        grade_id: 6, //年级
        subject_id: null, //科目
        version_id: null, //版本
        material_id: null,
        list_1_id: null,
        list_2_id: null,
        authonity: 1,
        is_download: 1,
        is_share: 1,
        cate_id: 0,
        //文件
        path: "",
        filesize: 0,
        postfix: "",
      },
      // 默认表单值，用于清空数据
      defaultForm: {
        resName: "",
        name: "",
        study_section_id: 2, //学段
        grade_id: 6, //年级
        subject_id: null, //科目
        version_id: null, //版本
        material_id: null,
        list_1_id: null,
        list_2_id: null,
        authority: 1,
        is_download: 1,
        is_share: 1,
        cate_id: 0,
        //文件
        path: "",
        filesize: 0,
        postfix: "",
      },
      //上传插件配置
      fileAdd: null, //添加的资料文件
      percentage: 0, //文件上传的实时进度
      uploadOptions: {
        target: this.BASE_URL + "/api/resource/res_upload",
        testChunks: false,
        headers: {
          Authorization: `Bearer ` + this.$g.access_token,
          DecisionPlatform: "logintable",
        },
        singleFile: true, //单文件上传，覆盖式。已选择一个文件，无论它是上传完还是正在上传中，若此时点击上传按钮选择一个文件上传，那新选择的文件会终止前面的文件，替换掉前面的文件
        allowDuplicateUploads: true, //允许一个已上传过的文件能再次被选中并上传
      },
      statusText: {
        success: this.$t("upload.success"),
        error: this.$t("upload.error"),
        uploading: this.$t("upload.uploading"),
        paused: this.$t("upload.paused"),
        waiting: this.$t("upload.waiting"),
      },
      attrs: {
        // accept: ['image/*', 'application/*', 'text/*', 'audio/*']
      },
      //正在保存...的提示
      submitLoading: false,
      cateList: [
        { id: 0, name: this.$t("global.all") },
        { id: -1, name: this.$t("global.defaultSort") },
      ], //资源分类列表
      activeClass: 0, //默认选中的分类
    };
  },
  created() {
    this.hostURL = sessionStorage.getItem("host_addr");
    this.getResource();
    // this.getDownLoadData();
    // this.getFavsData();
    // if (this.isTencentCloud) {
    //   this.getItcSortData();
    // } else {
    //   this.getResourceCate();
    // }
  },
  components: {
    ItcCate,
    CommonCate,
  },
  watch: {
    // 切换搜索条件 ：时间、下载、收藏，展示资料列表
    orderby(a, b) {
      if (a != b) {
        this.getResource();
      }
    },
    "$route.query.keyword"(value) {
      this.keyword = value;
      this.page_index = 1;
      this.getResource();
    },
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
    formRate() {
      return (vale) => {
        return Number(vale).toFixed(1);
      };
    },
  },
  methods: {
    changeOrderType(type) {
      if (type === "download") {
        this.orderby = "downloads";
      }
      if (type === "time") {
        this.orderby = "create_time";
      }

      this.getResource();
    },
    changeCateOption(cateOptions) {
      let val = 0;
      for (const key in cateOptions) {
        if (cateOptions[key]) {
          val = cateOptions[key];
        }
      }
      this.activeClass = val;
      this.resourceForm.cate_id = val;
      this.getResource();
    },
    getListData(val) {
      this.page_index = 1;
      this.resourceForm.cate_id = val;
      this.getResource();
    },
    async getItcSortData() {
      let success = (res) => {
        // 此函数是为了防止自动弹出操作成功提示
        return;
      };
      let { data: res1 } = await this.$ajax.get("api/video/video_cate", {
        params: {
          page_index: 1,
          page_size: 9999,
          status: 1,
          type: 1,
        },
        func: {
          success,
        },
      });
      let { data: res2 } = await this.$ajax.get("api/video/video_cate", {
        params: {
          page_index: 1,
          page_size: 9999,
          status: 1,
          type: 2,
        },
        func: {
          success,
        },
      });
      let data1 = res1.data.data.data;
      let data2 = res2.data.data.data;
      data1.forEach((element) => {
        data2.forEach((child) => {
          if (element.id === child.pid) {
            element.children = [];
            element.children.push(child);
          }
        });
      });
      // console.log(data1, data2);
      data1.unshift(
        { id: 0, name: this.$t("global.all") },
        { id: -1, name: this.$t("global.defaultSort") }
      );
      this.itcVideoCate = data1;
    },
    toResourceDetails(item) {
      // :to="{path: 'resourceDetail', query: {id: item.id}}"
      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll();
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          this.$router.push({
            path: "resourceDetail",
            query: {
              id: item.id,
            },
          });
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: 3,
          type_id: item.id,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str")).id,
        },
        func: { success },
      });
    },
    //获取资源分类
    getResourceCate() {
      let success = (res) => {
        this.cateList = [
          { id: 0, name: this.$t("global.all") },
          { id: -1, name: this.$t("global.defaultSort") },
        ].concat(res.data);
      };
      this.$ajax({
        url: "api/video/video_cate",
        method: "get",
        params: {
          status: 1,
        },
        func: {
          success: success,
        },
      });
    },
    //点击选择指定资源分类列表
    selectCate(val, item, type) {
      if (type === 1) {
        this.itcVideoCate2 = [];
        if (item.children) {
          this.itcVideoCate2 = item.children;
        }
      }
      this.activeClass = val;
      this.resourceForm.cate_id = val;
      this.getResource();
    },
    //时间、下载排序
    toggle_order(type) {
      this.orderby = type;
      this.getVideoData();
    },
    // 资料卡片列表
    getResource() {
      // console.log(this.study_section_id, this.grade_id, this.subject_id, this.keyword);
      let success = (res) => {
        this.resourceListData = res.data.rows;
        this.total_number = res.data.total;
        this.resourceListData.forEach((item) => {
          if (
            item.u_avatar_path.includes("/static/default/user_preview-1.png") ||
            item.u_avatar_path.includes("/public/picture")
          ) {
            item.u_avatar_path = this.BASE_URL + item.u_avatar_path;
          }
        });
      };
      this.$ajax({
        url: "api/resource/resource",
        method: "get",
        params: {
          orderby: this.orderby,
          page: this.page_index,
          size: this.page_size,
          data_type: 1,
          authonity: 1,
          not_in_file_type: 2,
          is_limit: 1,
          status: 1,
          res_use: this.keyword,
          cate_id: this.resourceForm.cate_id,
        },
        func: {
          success: success,
        },
      });
    },

    // 分页
    change_page(val) {
      this.page_index = val;
      this.getResource();
    },
    // 下载排行
    getDownLoadData() {
      let success = (res) => {
        if (res.data.length != 0) {
          this.downloadData = res.data;
        }
      };
      let params = {
        orderby: "downloads",
        page: 1,
        size: 8,
        authonity: 1,
        not_in_file_type: 2,
        is_limit: 1,
        status: 1,
        is_download: 1,
      };
      this.$ajax.get("api/resource/resource", {
        params,
        func: {
          success: success,
        },
      });
    },
    // 收藏排行
    getFavsData() {
      let success = (res) => {
        if (res.data.length != 0) {
          this.favsData = res.data;
        }
      };
      let params = {
        orderby: "favs",
        page: 1,
        size: 10,
        authonity: 1,
        is_limit: 1,
        not_in_file_type: 2,
        status: 1,
      };
      this.$ajax.get("api/resource/resource", {
        params,
        func: {
          success: success,
        },
      });
    },
    //上传我的资料按钮：
    uploadResource() {
      if (this.userId == 0) {
        this.$message.warning(this.$t("homepage.needLogin"));
        return false;
      }
      this.fileAdd = null;
      this.percentage = 0;
      this.resourceForm = deep_clone(this.defaultForm); //清空表单数据
      this.dialogVisible = true; //弹窗显示
    },
    fileAdded(file) {
      this.fileAdd = file;
    },
    fileSubmit(files, fileList, event) {
      // for (var i = 0; i < fileList.length; i++) {
      //   let video = fileList[i].fileType.slice(0, 5)
      //   if (video == 'video') {
      //     this.$message.warning('不支持视频文件上传')
      //     this.$refs.uploader.uploader.removeFile( fileList[i] );
      //     return false
      //   }else{
      //     this.fileAdd = fileList[i];
      //   }
      // }
      // console.log(files);
    },
    fileProgress() {
      this.percentage =
        parseInt(this.$refs.uploader.uploader.progress() * 100) <= 99
          ? parseInt(this.$refs.uploader.uploader.progress() * 100)
          : 99;
    },
    //上传成功的事件
    fileSuccess(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      mess = handleResponseData(mess);
      this.resourceForm.resName = mess.data.file_name;
      this.resourceForm.path = mess.data.file_path;
      this.resourceForm.filesize = mess.data.file_size;
      this.resourceForm.postfix = mess.data.post_fix;
      this.percentage = 100;
    },
    // 上传失败
    fileFail(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
        let callbcak = (data) => {
          this.uploadRetryTimes--;
          this.$refs.uploader.uploader.retry(file);
        };
        this.get_access_token(callbcak);
      } else {
        this.$message.error(mess.message);
      }
    },
    // 保存按钮
    submit() {
      if (this.fileAdd == null) {
        this.$message.warning(this.$t("form.chooseFile"));
        return;
      }
      if (this.percentage < 100) {
        this.$message.warning(this.$t("upload.uploading"));
        return;
      }
      if (this.resourceForm.name == "") {
        this.$message.warning(this.$t("form.resEmpty"));
        return;
      }
      this.submitLoading = true;
      let success = (res) => {
        this.submitLoading = false;
        this.dialogVisible = false;
        let role = this.$store.getters.userInfo.role;
        // 1\2\3都属于管理员；这类身份提交的资料都不需要审核
        if (
          role.indexOf(1) > -1 ||
          role.indexOf(2) > -1 ||
          role.indexOf(3) > -1
        ) {
          this.$message.success(this.$t("upload.success"));
        } else {
          this.$message.success(this.$t("homepage.Moderated"));
        }
        this.resourceForm = deep_clone(this.defaultForm);
        this.getResource();
        this.getDownLoadData();
      };
      let fail = (res) => {
        this.submitLoading = false;
        this.dialogVisible = false;
        this.$message.error(this.$t("upload.fail"));
      };
      this.$ajax({
        url: "api/resource/vue_resource",
        method: "post",
        data: this.resourceForm,
        func: {
          success: success,
          fail: fail,
        },
      });
    },
  },
};
</script>
<style lang="scss">
$bg_3: #ffffff; //white - bg
$shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
$shadow2: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
$sc_6: #e62125; //Main color
$font: 16px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1, Tahoma,
  Arial, sans-serif;

.i_transition {
  -moz-transition: all 0.35s ease-in;
  -webkit-transition: all 0.35s ease-in;
  -o-transition: all 0.35s ease-in;
  transition: all 0.35s ease-in;
}

.video_view {
}

.resource-index {
  // padding-bottom: 20px;
  margin: auto;
  margin-top: 9%;
}

.resource-cate {
  margin-top: 20px;
  padding-bottom: 20px;
  min-height: 50px;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #020202;
  line-height: 19px;

  .cate-left {
    padding: 25px;
    float: left;
    width: 6%;
  }

  .cate-right {
    width: 85%;
    float: left;

    ul li {
      display: inline-block;
      /*width: 11%;*/
      padding: 25px 50px 0 0;
      color: #666666;
      cursor: pointer;

      &:hover {
        color: #e62125;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .cate-active {
      color: #e62125;
    }
  }
}

.el-dialog {
  .el-dialog__header {
    background-color: #338efc;
    padding: 8px 20px 8px;
  }

  .el-dialog__body {
    padding: 30px 40px 10px;
  }

  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }

  .el-dialog__headerbtn {
    top: 8px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 24px;
  }

  .el-dialog__headerbtn .el-dialog__close:hover {
    color: rgba(255, 255, 255, 0.8);
  }
}

// course-box
.course-box {
  padding: 20px 20px 13px 20px;
  background: #ffffff;
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-top: 3px;
  margin: 20px 0;
  overflow: hidden;
}

.course-sub {
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 10px;
}

.course-sub > span {
  display: block;
  float: left;
  color: #666666;
  width: 60px;
  overflow: hidden;
  height: 19px;
  text-align: left;
}

.course-sub:last-of-type {
  margin-bottom: 0;
}

.course-li {
  margin-left: 60px;
  min-height: 29px;
}

.course-li > label {
  float: left;
  color: #000000;
  cursor: pointer;
  margin: 0 3.7735849057% 10px 0;
}

.course-li > label > input:checked + span {
  color: #e62125;
}

.course-li > label input {
  display: none;
}

.course-li > label:hover {
  color: #61a4f5;
}

// course-box
.filter-nav {
  padding: 0;
  margin-bottom: 20px;
  box-shadow: none;

  .el-radio-group {
    padding: 10px;
    background: #fff;
    // box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

    .el-radio {
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      margin-right: 5px;
      text-align: center;
      color: #727272;
    }

    .is-checked {
      color: #fff;
      border-radius: 2px;
      background: #e62126;

      .el-radio__label {
        padding: 0;
        color: #fff;
      }
    }
  }

  .el-radio__input {
    display: none;
  }
}

.resources-container {
  .resource-card-box {
    display: inline-block;
    width: 100%;
    height: 750px;

    .cards-box {
      height: 100%;
    }

    .cards-box-ul {
      // height: 690px;
    }

    .cards-li {
      box-sizing: border-box;
      width: 288px;
      height: 160px;
      background: $bg_3;
      padding: 23/1200 * 100% 21/1200 * 100% 17/1200 * 100% 12/1200 * 100%;
      // -webkit-box-shadow: $shadow2;
      // -moz-box-shadow: $shadow2;
      // box-shadow: $shadow2;
      -moz-border-radius: 3px;
      border-radius: 3px;
      @extend .i_transition;
      margin: 0 16px 16px 0;

      &:nth-of-type(4n) {
        margin: 0 0 16px 0;
      }

      &:hover {
        -webkit-box-shadow: $shadow;
        -moz-box-shadow: $shadow;
        box-shadow: $shadow;

        .cards-li-title {
          .res-title {
            color: $sc_6;
          }
        }
      }
    }

    .cards-li-title {
      .res-title {
        display: block;
        float: left;
        font: $font;
        line-height: 22px;
        width: 74%;
        height: 48px;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    .user-infos {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > a {
        display: block;
        line-height: 25px;
        font-size: 12px;
        > img {
          width: 25px;
          height: 25px;
          -moz-border-radius: 50%;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 5px;
        }
      }
      .cate {
        width: 87px;
        padding: 0 5px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e8e9e9;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #727e90;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap;
      }
    }

    .rate-star {
      height: 40px;
      padding-top: 10px;
      line-height: 19px;
      // margin: 10px 0 20px 0;
    }

    .rate-score {
      > strong {
        float: left;
        margin-left: 12px;
        color: #ff6525;
      }
    }

    .collect {
      .praise {
        background-position: -544px -782px;
        width: 14px;
        height: 14px;
      }

      > i {
        vertical-align: middle;
      }

      > strong {
        color: #888;
        margin-left: 5px;
      }
    }
  }

  .dependent {
    height: 100%;
    text-align: center;
    background-color: #fff;

    i {
      margin: 150px 0 30px;
    }

    p {
      color: #666;
    }
  }

  .pageBox {
    margin-top: 18px;
  }

  // .resource-rank {
  //   display: inline-block;
  //   width: 280px;
  //   // height: 807px;
  //   // background-color: #fff;

  //   .upload-btn-div {
  //     height: 52px;
  //     line-height: 52px;
  //     text-align: center;
  //     color: #E62126;
  //     border-radius: 4px;
  //     /*background-color: #4477C3;*/
  //     cursor: pointer;
  //     background: #ffffff;
  //     box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  //     margin-bottom: 20px;
  //     img {
  //       vertical-align: middle;
  //       margin-right: 5px;
  //     }

  //     i {
  //       vertical-align: middle;
  //     }
  //   }

  //   .upload-rank {
  //     // margin-top: 20px;
  //   }

  //   .box-card {
  //     border: none;

  //     // .humantitle {
  //     //   padding: 5px 8px;
  //     //   border-radius: 2px;
  //     //   font-size: 14px;
  //     //   color: #666;
  //     // }

  //     .el-card__header {
  //       // padding: 16px 10px;
  //       padding: 0;
  //       margin: 0 17px;
  //       height: 36px;
  //       line-height: 36px;
  //       font-size: 14px;
  //       color: #666666;
  //       // border-bottom: solid 2px #e5e5e5;
  //       border: 0 none;
  //     }

  //     .el-card__body {
  //       // height: 299px;
  //       // padding: 14px 20px;
  //       padding: 0 17px 20px;
  //     }

  //     .humanItem {
  //       // padding: 5px 0;
  //       height: 60px;
  //       border-bottom: 1px solid #efefef;
  //     }

  //     .humanItem i {
  //       position: relative;
  //       top: -16px;
  //       width: 24px;
  //       height: 24px;
  //       line-height: 24px;
  //       font-size: 12px;
  //       border-radius: 4px;
  //     }

  //     .humanItem a {
  //       display: inline-block;
  //       width: 80%;
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //       overflow: hidden;
  //     }

  //     .humanItem p {
  //       margin-top: 10px;
  //       height: 20px;
  //       line-height: 20px;
  //       font-size: 14px;
  //       color: #020202;
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //       overflow: hidden;
  //     }

  //     .humanItem div {
  //       margin-top: 5px;
  //       height: 16px;
  //       line-height: 16px;
  //       font-size: 12px;
  //       color: #666666;
  //     }

  //     .humanItem:hover {
  //       background-color: #effaff;
  //     }

  //     .humanItem:hover > a {
  //       color: #E62125;
  //     }

  //     .humanNun {
  //       display: inline-block;
  //       width: 20px;
  //       height: 20px;
  //       line-height: 20px;
  //       text-align: center;
  //       color: #ffffff;
  //       background: #d2d2d2;
  //       margin-right: 10px;
  //     }

  //     .humanNun.yellowC {
  //       background: #f2b732;
  //     }
  //   }

  //   .upload-rank .el-card {
  //     // border-bottom: 1px dashed #d7d7d7;
  //   }
  // }

  .no-data {
    color: #ccc;
    text-align: center;
    padding: 70px 0;
  }
}

.resourceDialog {
  .long-item {
    width: 100%;
  }

  .upload-btn-item {
    .el-button {
      padding: 0;
      width: 100px;
      height: 34px;
    }

    .tip-word {
      font-size: 20px;
      cursor: pointer;
    }

    .progress-tips {
      .file-name {
        color: #409eff;
      }

      .file-type {
        margin: 0 50px;
      }

      .progress-value {
        color: #13ce66;
      }
    }
  }

  .resource-name-item {
    .el-form-item__content {
      width: 66%;
    }

    .el-input__inner {
      height: 36px;
    }
  }

  .el-select .el-input__inner {
    width: 140px;
    height: 34px;
    line-height: 34px;
  }

  .grade-item,
  .subject-item,
  .material-item,
  .cate-item {
    .el-form-item__label {
      text-align: end;
    }
  }

  .btns-item {
    width: 100%;
    text-align: center;

    .el-button {
      padding: 0;
      width: 100px;
      height: 34px;
    }
  }

  .uploader-example {
    display: inline-block;

    .uploader-drop {
      padding: 0px;
      border: none;
      background-color: transparent;
    }

    .uploader-btn {
      border-radius: 4px;
      padding: 7px 16px;
      margin-right: 15px;
      color: #fff;
      background-color: #409eff;
      border: 1px solid transparent;
    }

    .uploader-btn:hover {
      background: rgba(51, 142, 252, 0.8);
    }
  }
}
</style>
